import { Requests, RequestStatus } from '../types/Requests';

export const requests: Requests = {
  failed: false,
  fetching: true,
  data: {
    currentPage: 1,
    pageSize: 15,
    filters: [],
    sort: {
      applied: false,
      colIndex: -1
    }
  }
};

export const requestStatus: RequestStatus = {
  failed: false,
  fetching: false,
  retryFailed: false,
  retryLoading: false
};
